module.exports = __webpack_public_path__ + "static/img/brand-fourth-left.5b3101c1.png";